import { Box, Grid, Paper } from '@mui/material'
import React from 'react'
import { addActiveClass, customStyles, spaceBetween } from '../../../styles'
import { CaptionText, MainButton, RegularText, SmallText } from '../../helpers'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getTrackingOrder } from '../../../slices/orderSlice';

export const CardItem = (props) => {
  const { success } = customStyles.colors
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { data } = props
  const handleNavigate = () => {
    dispatch(getTrackingOrder({...data, justRead: true}))
     navigate(`/dashboard/track-order`)
  }
  return (
    <Grid item xs={12} sm={6} sx={{ marginBottom: 3, animationDelay: props.delay, ...addActiveClass }}  className={props.animation}>
      <Paper sx={{ padding: 1, borderRadius: 1 }}>
      <Box sx={spaceBetween}>
        <RegularText text={`Gas ${data?.type}`}/>
        <RegularText text={`$ ${data?.total}`}/>
      </Box>
      <Box sx={spaceBetween}>
        <Box sx={{ ...spaceBetween, width: 200 }}>
          <CaptionText text={`${data?.date} - ${data?.end}`}/>
          
        </Box>
        {/* <ChevronRightIcon onClick={() => handleNavigate('wop')} sx={{cursor: 'pointer'}}/> */}
      </Box>
      <Box sx={spaceBetween} mt={1}>
      <RegularText text={data?.statusLabel} color={data?.colorStatus}/>
        <MainButton text="Volver a pedir" variant="contained" size={ customStyles.buttonSize.medium } onClick={() => handleNavigate('wop')}/>
      </Box>
      </Paper>
    </Grid>
  )
}
